'use client';

import { useState } from 'react';
import { Accordion } from '@/components/Accordion';
import { FaqData } from './FaqSection.copy';

export function FaqAccordion() {
  const [openIndex, setOpenIndex] = useState<number>(-1);

  return (
    <div className="flex flex-col gap-5">
      {FaqData.map((item: { title: string; content: JSX.Element }, index) => (
        <Accordion
          key={item.title.slice(6)}
          index={index}
          isOpen={openIndex === index}
          setOpenIndex={setOpenIndex}
          title={item.title}
        >
          {item.content}
        </Accordion>
      ))}
    </div>
  );
}
